import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { Loading } from '../WithLoading/Loading';
import { EmptyState } from '../WithEmptyState/EmptyState';
import { Text } from '../../UI/Text';
import { MembersEmptyState } from '../../Components/BannerEmptyStats/BannerEmptyStats';
import { Container, SearchRow, SearchInput, AddButton } from './style';
import MemberRow from '../../Components/Rows/MemberRow';
import WaitingMemberRow from '../../Components/Rows/MemberRow/WaitingMemberRow';
import ModalContainer from '../Modals/ModalContainer';
import AddmemberModal from '../../Components/Modals/AddMemberModal';
import { MemberRowHeader } from '../../Components/Rows/MemberRow/Header';
import { Row } from '../../Layouts';
import { MembersActionCreators } from '../../../Store/ActionCreators/MembersActionCreators';
import { MembershipPlansActionCreators } from '../../../Store/ActionCreators/MembershipPlansActionCreators';

class Members extends Component {
    state = {
        addModalOpen: false,
        rowSelectOpen: null,
        rowStatusOpen: null,
        paidUntilSelectOpenId: null,
        searchQuery: '',
        hiddenPlaceholder: false,
    };

    setInputNode = node => (this.inputFiled = findDOMNode(node));

    handleSearch = e => {
        this.setState({ searchQuery: e.target.value });
    };

    handlePlaceholder = hidden => event => {
        const text = this.inputFiled.value.trim().length;

        if (!text) {
            return this.setState({ hiddenPlaceholder: hidden });
        }
    };

    componentDidMount() {
        this.props.getMembers();
        this.props.getWaitingMembers();
        this.props.getMembershipPlans();
    }

    toggleAddModal = () => {
        this.setState({ addModalOpen: !this.state.addModalOpen });
    };

    toggleSelect = id => {
        this.setState({ rowSelectOpen: id });
    };

    toggleStatusClick = id => {
        this.setState({ rowStatusOpen: id });
    };

    togglePaidUntilSelect = id => {
        this.setState({ paidUntilSelectOpenId: id });
    };

    closeAllWindows = () => {
        this.setState({ paidUntilSelectOpenId: null, rowSelectOpen: null, rowStatusOpen: null });
    };

    render() {
        const {
            areMembersLoading,
            members,
            arePlansLoading,
            plans,
            waitingMembersLoading,
            waitingMembers,
            updateMemberStatus,
            resendMemberInvitation,
            resendEmail,
        } = this.props;
        const { addModalOpen, searchQuery, rowSelectOpen, paidUntilSelectOpenId, rowStatusOpen } = this.state;
        const membersList = members.filter(member =>
            member.user.fullName.toLowerCase().includes(searchQuery.toLowerCase()),
        );
        const waitingMembersList = waitingMembers.filter(member =>
            member.fullName.toLowerCase().includes(searchQuery.toLowerCase()),
        );

        const isEmpty = [...membersList, ...waitingMembersList].length === 0;

        return (
            <Container>
                {addModalOpen && (
                    <ModalContainer>
                        <AddmemberModal onClose={this.toggleAddModal} />
                    </ModalContainer>
                )}

                <SearchRow>
                    <SearchInput
                        disabled={areMembersLoading}
                        ref={this.setInputNode}
                        onChange={this.handleSearch}
                        placeholder={'Search members'}
                    />

                    <Row>
                        <Text weight={100} opacity={0.75} fontSize={12} marginRight={'15px'}>
                            Changes made will be instantly saved
                        </Text>
                        <AddButton disabled={areMembersLoading} onClick={this.toggleAddModal}>
                            Add
                        </AddButton>
                    </Row>
                </SearchRow>

                <Loading isLoading={areMembersLoading || arePlansLoading || waitingMembersLoading}>
                    <EmptyState isEmpty={isEmpty} emptyState={MembersEmptyState}>
                        <MemberRowHeader />
                        {membersList.map((member, index) => (
                            <MemberRow
                                updateStatus={updateMemberStatus}
                                resendInvitation={resendMemberInvitation}
                                closeAll={this.closeAllWindows}
                                {...member}
                                plansAvailable={plans}
                                rowSelectOpen={rowSelectOpen}
                                paidUntilSelectOpenId={paidUntilSelectOpenId}
                                handleSelect={this.toggleSelect}
                                handleStatusClick={this.toggleStatusClick}
                                rowStatusOpen={rowStatusOpen}
                                handlePaidUntilSelect={this.togglePaidUntilSelect}
                                onDelete={this.props.deleteMember}
                                onMembershipTypeAdded={this.props.addPlansToMember}
                                key={index}
                            />
                        ))}
                        {waitingMembersList.map((member, index) => (
                            <WaitingMemberRow
                                {...member}
                                updateStatus={updateMemberStatus}
                                resendInvitation={resendMemberInvitation}
                                resendEmail={resendEmail}
                                closeAll={this.closeAllWindows}
                                id={`${index}-waiting`}
                                status={0}
                                handleStatusClick={this.toggleStatusClick}
                                rowStatusOpen={rowStatusOpen}
                                onDelete={this.props.deleteMember}
                                key={`${index}-waiting`}
                            />
                        ))}
                    </EmptyState>
                </Loading>
            </Container>
        );
    }
}

const mapStateToProps = ({
    members: {
        statuses: { areMembersLoading, waitingMembersLoading },
        members,
        waitingMembers,
    },
    membershipPlans: {
        statuses: { arePlansLoading },
        plans,
    },
}) => ({
    areMembersLoading,
    members,
    arePlansLoading,
    plans,
    waitingMembersLoading,
    waitingMembers,
});

const mapDispatchToProps = dispatch => ({
    getMembers() {
        dispatch(MembersActionCreators.getMembersRequest());
    },
    getMembershipPlans() {
        dispatch(MembershipPlansActionCreators.getMembershipPlansRequest());
    },
    deleteMember(id) {
        dispatch(MembersActionCreators.deleteMemberRequest(id));
    },
    addPlansToMember(id, plans, cb) {
        dispatch(MembersActionCreators.addMembershipPlanToMemberRequest(id, plans, cb));
    },
    getWaitingMembers() {
        dispatch(MembersActionCreators.getWaitingMembersRequest());
    },
    resendMemberInvitation(memberId) {
        dispatch(MembersActionCreators.resendInvitationRequest(memberId));
    },
    updateMemberStatus(memberId, status, callback) {
        dispatch(MembersActionCreators.updateMemberStatusRequest(memberId, status, callback));
    },
    resendEmail(memberInfo, callback) {
        dispatch(MembersActionCreators.inviteMemberByEmailRequest(memberInfo, callback));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Members);



// WEBPACK FOOTER //
// ./src/UI/Containers/Members/index.js